module.exports = __webpack_public_path__ + "img/kppz4.288ac471.png";